import { render, staticRenderFns } from "./applyRecord.vue?vue&type=template&id=0b1d350c&scoped=true"
import script from "./applyRecord.vue?vue&type=script&lang=js"
export * from "./applyRecord.vue?vue&type=script&lang=js"
import style0 from "./applyRecord.vue?vue&type=style&index=0&id=0b1d350c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d350c",
  null
  
)

export default component.exports